/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/camelcase */
/** ============================ */
/*  This file was autogenerated  */
/*  with `npm run codegen`       */
/* ============================= */

import { gql } from "@apollo/client";
import * as ApolloReactCommon from "@apollo/client";
import * as ApolloReactHooks from "@apollo/client";

import * as Types from "../../../api/types.generated";
export type UpdateHardwareSkuMutationVariables = Types.Exact<{
  code: Types.Scalars["String"];
  name?: Types.Maybe<Types.Scalars["String"]>;
  description?: Types.Maybe<Types.Scalars["String"]>;
  image?: Types.Maybe<Types.Scalars["String"]>;
  location?: Types.Maybe<Types.Scalars["String"]>;
  category_id?: Types.Maybe<Types.Scalars["Float"]>;
}>;

export type UpdateHardwareSkuMutation = {
  updateHardwareSku: Pick<
    Types.HardwareSku,
    "code" | "name" | "description" | "image" | "location" | "category_id"
  >;
};

export const UpdateHardwareSkuDocument = gql`
  mutation UpdateHardwareSku(
    $code: String!
    $name: String
    $description: String
    $image: String
    $location: String
    $category_id: Float
  ) {
    updateHardwareSku(
      code: $code
      name: $name
      description: $description
      image: $image
      location: $location
      category_id: $category_id
    ) {
      code
      name
      description
      image
      location
      category_id
    }
  }
`;

/**
 * __useUpdateHardwareSkuMutation__
 *
 * To run a mutation, you first call `useUpdateHardwareSkuMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateHardwareSkuMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateHardwareSkuMutation, { data, loading, error }] = useUpdateHardwareSkuMutation({
 *   variables: {
 *      code: // value for 'code'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      image: // value for 'image'
 *      location: // value for 'location'
 *      category_id: // value for 'category_id'
 *   },
 * });
 */
export function useUpdateHardwareSkuMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UpdateHardwareSkuMutation,
    UpdateHardwareSkuMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<
    UpdateHardwareSkuMutation,
    UpdateHardwareSkuMutationVariables
  >(UpdateHardwareSkuDocument, baseOptions);
}
export type UpdateHardwareSkuMutationHookResult = ReturnType<
  typeof useUpdateHardwareSkuMutation
>;
export type UpdateHardwareSkuMutationResult =
  ApolloReactCommon.MutationResult<UpdateHardwareSkuMutation>;
export type UpdateHardwareSkuMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    UpdateHardwareSkuMutation,
    UpdateHardwareSkuMutationVariables
  >;
